<template>
  <div class="user-dashboard">
    <!-- Sidebar -->
    <UserSidebar 
      ref="userSidebar"
      :sidebarOpen="sidebarOpen" 
      :menuItems="menuItems"
      @close-sidebar="sidebarOpen = false" 
    />

    <!-- Content area -->
    <div class="user-main">
      <!-- Site header -->
      <UserHeader 
        :sidebarOpen="sidebarOpen" 
        @toggle-sidebar="sidebarOpen = !sidebarOpen"
        @start-guide-tour="runGuideTour"
        :class="{ 'user-header--behind': isPredixRoute }"
      />

      <main
        class="user-main-content"
        :class="{
          'user-main-content--flush': isPredixRoute,
          'user-main-content--predix': isPredixRoute,
        }"
      >
        <router-view v-if="isPredixRoute"></router-view>
        <v-slide-x-transition v-else mode="out-in">
          <router-view></router-view>
        </v-slide-x-transition>
      </main>
    </div>
  </div>
</template>

<script>
import { getPackages } from "@/api/user/dataset";
import UserSidebar from '@/components/user/UserSidebar.vue';
import UserHeader from '@/components/user/UserHeader.vue';
import {
  consumePendingUserTour,
  hasCompletedUserTour,
  startUserTour,
} from '@/utils/userTour';

export default {
  name: "Home",
  components: {
    UserSidebar,
    UserHeader
  },
  computed: {
    isPredixRoute() {
      const path = this.$route.path
      return typeof path === 'string' && (path.startsWith('/panel/predix') || path.startsWith('/panel/ipredix'))
    },
    menuItems() {
      return this.menuItemData.map((item) => {
        let x = item;
        x.active = false
        if (item.to === this.$route.path || (item.sub && item.sub.findIndex(x => x.to === this.$route.path) > -1)){
          x.active = true
        } 
        return x;
      });
    },
  },
  data: () => ({
    sidebarOpen: false,
    grantedPackages: [],
    tourStarted: false,
    menuItemData: [
      {
        id: "HOME",
        name: "HOME",
        icon: "menu-home",
        to: "/user/home",
        disabled: false,
        sub: [],
      },
      {
        id: "I_PREDIX",
        name: "PrediX™",
        icon: "menu-ipredix",
        to: "/panel/predix",
        disabled: false,
        sub: [],
      },
      {
        id: "I_MAT",
        name: "AlloyNx™",
        icon: "menu-imat",
        to: "/panel/module-info/alloynx",
        disabled: false,
        locked: true,
        // sub: [
        //   {
        //     id: "I_MAT_CASTING",
        //     name: "Casting",
        //     icon: "menu-imat",
        //     to: "/panel/alloyDesign/casting",
        //     disabled: false,
        //   },
        //   {
        //     id: "I_MAT_WROUGHT",
        //     name: "Wrought",
        //     icon: "menu-imat",
        //     to: "/panel/alloyDesign/wrought",
        //     disabled: true,
        //   },
        //   {
        //     id: "I_MAT_ADDITIVE",
        //     name: "Additive",
        //     icon: "menu-imat",
        //     to: "/panel/alloyDesign/casting",
        //     disabled: true,
        //   },
        // ],
      },
      {
        id: "I_PRO",
        name: "ProNx™",
        icon: "menu-ipro",
        to: "/panel/module-info/pronx",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_ENGINE",
        name: "EngineX™",
        icon: "menu-ai-model-development",
        to: "/panel/module-info/enginex",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_HEAT",
        name: "HeatNx™",
        icon: "menu-iheat",
        to: "/panel/module-info/heatnx",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_BOOST",
        name: "AlgoNx™",
        icon: "menu-iboost",
        to: "/panel/module-info/algonx",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_TRAIN",
        name: "BrainNx™",
        icon: "menu-itrain",
        to: "/panel/module-info/brainnx",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_MELT",
        name: "MeltNx™",
        icon: "menu-imelt",
        to: "/panel/module-info/meltnx",
        disabled: false,
        locked: true,
        sub: [],
      },
      {
        id: "I_TARGET",
        name: "TargetX™",
        icon: "menu-ipredix",
        to: "/panel/module-info/targetnx",
        disabled: false,
        locked: true,
        sub: [],
      },
    ],
  }),
  methods: {
    logout() {
      this.$store.commit("logout");
      this.$router.push("/login");
    },
    prepareTourSidebar() {
      this.sidebarOpen = true
      if (this.$refs.userSidebar && typeof this.$refs.userSidebar.ensureSidebarExpanded === 'function') {
        this.$refs.userSidebar.ensureSidebarExpanded()
      } else {
        try {
          localStorage.setItem('sidebar-expanded', 'true')
        } catch (e) {
          /* ignore */
        }
        document.body.classList.add('sidebar-expanded')
      }
    },
    runGuideTour() {
      if (this.$store.state.IsStaff) return
      this.prepareTourSidebar()
      startUserTour({
        username: this.$store.state.Username,
        markComplete: true,
        router: this.$router,
        prepareSidebar: () => this.prepareTourSidebar(),
      })
    },
    loadPackages() {
      const _this = this;
      getPackages(function (res) {
        _this.grantedPackages = res;
        for (var pkg of res) {
          if (pkg.name.endsWith("_ALLOY_DESIGN")) {
            _this.menuItems[_this.menuItems.findIndex((item) => item.id === "ALLOY_DESIGN")].disabled = false;
          } else if (pkg.name.startsWith("HT_")) {
            _this.menuItems[_this.menuItems.findIndex((item) => item.id === "HT_DESIGN")].disabled = false;
          } else {
            _this.menuItems[_this.menuItems.findIndex((item) => item.id === pkg.name)].disabled = false;
          }
        }
      });
    },
    maybeStartFirstLoginTour() {
      if (this.tourStarted) return
      if (this.$store.state.IsStaff) return
      if (!this.$store.state.Login) return

      const username = this.$store.state.Username
      const pending = consumePendingUserTour()
      const firstTime = !hasCompletedUserTour(username)
      if (!pending && !firstTime) return

      this.tourStarted = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.prepareTourSidebar()
          startUserTour({
            username,
            markComplete: true,
            router: this.$router,
            prepareSidebar: () => this.prepareTourSidebar(),
          })
        }, 500)
      })
    },
  },
  created() {
    // this.loadPackages();
  },
  mounted() {
    this.maybeStartFirstLoginTour()
  },

  //   mounted: function() {
  //   let elHtml = document.getElementsByTagName('html')[0]
  //   elHtml.style.overflowY = 'hidden'
  // },
  // destroyed: function() {
  //   let elHtml = document.getElementsByTagName('html')[0]
  //   elHtml.style.overflowY = null
  // }
};
</script>
<style scoped lang="scss">
@import '@/assets/styles-user-dashboard.scss';
</style>
